import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AbstractListComponent } from '../../common/abstract-list-component';
import { PrintLog } from '../../model/print-log';
import { takeUntil } from 'rxjs/operators';
import { Table } from 'primeng/table/table';
import { PrintLogService } from 'src/app/service/print-path.service';

@Component({
    selector: 'app-print-log-list',
    templateUrl: './print-log-list.component.html',
})
export class PrintLogListComponent extends AbstractListComponent<PrintLog> implements OnInit {
    element: PrintLog;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected printLogService: PrintLogService
    ) {
        super(router, printLogService, 'print_logs');
    }

    ngOnInit() {
        this.loading = true;
        this.element = new PrintLog();
    }

    newElement(): PrintLog {
        return super.newElement();
    }

    delete(element: PrintLog) {
        this.service
            .delete(element.uuid)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.loaddata(true));
    }

    public reload(datatable: Table) {
        super.reload(datatable);
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                received_date: this.service.search.from?.received_date?.split('T')[0],
            },
            to: {
                ...this.service.search.to,
                received_date: this.service.search.to?.received_date?.split('T')[0],
            },
        };
    }

    getId() {
        return this.element.uuid;
    }

    createInstance(): PrintLog {
        return new PrintLog();
    }

    public preLoaddata() {
        this.appendHourToDate();
    }

    private normalizeDateFilter(dateValue: string, endOfDay = false): string {
        if (!dateValue) {
            return null;
        }

        const dateOnly = dateValue.split('T')[0];
        const separator = dateOnly.includes('/') ? '/' : '-';
        const dateParts = dateOnly.split(separator);

        if (dateParts.length !== 3) {
            return null;
        }

        const normalizedDate =
            dateParts[0].length === 4
                ? `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`
                : `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

        return `${normalizedDate}${endOfDay ? 'T23:59:59' : 'T00:00:00'}`;
    }

    public formatDateChip(dateValue: string): string {
        if (!dateValue) {
            return '';
        }

        const dateOnly = dateValue.split('T')[0];
        const dateParts = dateOnly.split('-');

        if (dateParts.length !== 3) {
            return dateOnly;
        }

        return dateParts[0].length === 4
            ? `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
            : `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
    }

    appendHourToDate() {
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                received_date: this.normalizeDateFilter(this.service.search?.from?.received_date),
            },
            to: {
                ...this.service.search.to,
                received_date: this.normalizeDateFilter(
                    this.service.search?.to?.received_date,
                    true
                ),
            },
        };
    }
}
